import React from "react";

export default function Pagination(props) {

  const onNextPageChange = () => {
    const nextPage = props.filters.page + 1;
    props.onPageChange({ page: nextPage });
  };

  const onPreviousPageChange = () => {
    const nextPage = props.filters.page - 1;
    props.onPageChange({ page: nextPage });
  };

  const getPageNumber = () => {
    let pageNumbers = [];

    for (
      let i = 1;
      i <=
      Math.ceil(props.results.total_records / props.filters.pageSize);
      i++
    ) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const getCurrentPage = () => {
    return props.filters.page;
  };

  const getInitPageRange = () => {
    return props.filters.page < 3 ? 1 : 3;
  };

  const getLastPage = () => {
    let lastPage = getPageNumber().length - 1;
    return lastPage;
  };

  const style = {
    active: {
      backgroundColor: "#046B99",
      color: "white",
      padding: "0.5rem 0.25rem",
    },
    inactive: {
      padding: "0.5rem 0.25rem",
    },
  };

  const pagination = getPageNumber()
    .map((page) => (
      <li className="page-item" key={page}>
        <a
          style={
            getCurrentPage() == page ? style.active : style.inactive
          }
          className="page-link"
          onClick={() => props.onPageChange({ page: page })}
        >
          {page}
        </a>
      </li>
    ))
    .splice(getCurrentPage() - getInitPageRange(), 8);

  if (props.results.total_records === 0) {
    return <div />;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <nav aria-label="">
        <ul className="pagination justify-content-center">
          <li className={props.filters.page === 1 ? "page-item disabled" : "page-item"}>
            <a
              className="page-link"
              onClick={
                props.filters.page === 1 ? null : () => props.onPageChange({ page: 1 })
              }
              tabIndex="-1"
            >
              First
              </a>
          </li>
          <li className={props.filters.page === 1 ? "page-item disabled" : "page-item"}>
            <a
              className="page-link"
              onClick={props.filters.page === 1 ? null : onPreviousPageChange}
              tabIndex="-1"
            >
              Previous
              </a>
          </li>
          {pagination}
          <li
            className={
              props.filters.page == getLastPage() || props.filters.page == getLastPage() + 1
                ? "page-item disabled"
                : "page-item"
            }
          >
            <a
              className="page-link"
              onClick={props.filters.page === getLastPage() ? null : onNextPageChange}
            >
              Next
              </a>
          </li>
          <li
            className={
              props.filters.page == getLastPage() + 1
                ? "page-item disabled"
                : "page-item"
            }
          >
            <a
              className="page-link"
              onClick={
                props.filters.page === getLastPage() + 1
                  ? null
                  : () =>
                    props.onPageChange({
                      page: getLastPage() + 1,
                    })
              }
            >
              Last
              </a>
          </li>
        </ul>
        {props.results.total_records > 0 ? (
          <div style={{ textAlign: "left", width: "100%" }}>
            {/* <CSVLink data={this.state.results}>
                <button type="submit" className="ca-gov-icon-attachment" style={{ position: 'relative', height: '35px', width: '50px', top: '-53px', fontSize: '1.5em' }}></button>
              </CSVLink> */}
          </div>
        ) : (
            ""
          )}
      </nav>
        Page: {getCurrentPage()} of{" "}
      {Math.ceil(
        props.results.total_records / props.filters.pageSize
      )}
    </div>
  );
}
